import { Input } from "antd";
import { useCallback, useEffect, useMemo, useRef } from "react";
import SearchIcon from "../assets/search-normal.svg";

export const CommanSearchBox = ({
  value,
  setValue,
  getSearchValue,
  userRecord,
  isPagination = true,
  placeholder = "",
}) => {
  const timerRef = useRef(null);

  const sendRequest = useCallback(
    (searchVal) => {
      if (isPagination) {
        getSearchValue(1, 10, searchVal);
      } else {
        getSearchValue(userRecord, searchVal);
      }
    },
    [getSearchValue, isPagination, userRecord]
  );

  const handleOnChange = (event) => {
    const inputVal = event.target.value;
    setValue(inputVal); // Don’t trim here; user may be typing spaces intentionally

    // Clear previous timer
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    // Debounce new timer
    timerRef.current = setTimeout(() => {
      sendRequest(inputVal.trim()); // Trim just before sending
    }, 1000);
  };

  // Optional cleanup on unmount
  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return (
    <Input
      className="table-search-input form-control w-50"
      placeholder={`Search ${placeholder}`}
      prefix={
        <img
          src={SearchIcon}
          height={"24px"}
          width={"24px"}
          alt="Search Icon"
        />
      }
      value={value}
      onChange={handleOnChange}
    />
  );
};
